import { render, staticRenderFns } from "./CellRendererDetail.vue?vue&type=template&id=4b46b6d1&"
import script from "./CellRendererDetail.vue?vue&type=script&lang=js&"
export * from "./CellRendererDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports